<template>
  <section
    :class="{
      [lightTextClass]: true,
      'background-image-wrapper': true,
    }"
    :style="backgroundImageClass"
  >
    <slot />
  </section>
</template>

<script lang="ts" setup>
import type { ImageBackground } from '~/sanity/types';
type ExtraProps = {
  // only use above the fold
  preload?: boolean;
};
const props = defineProps<ImageBackground & ExtraProps>();
const { background, lightText } = toRefs(props);

// only preload above the fold, the parent component is responsible for setting this
if (props.preload && background.value && background.value.asset?._ref) {
  preloadImgSrc(cdnImage(background.value.asset._ref).bg);
}

const backgroundImageClass = computed(() => {
  if (!background.value || background.value._type !== 'image' || !background.value.asset?._ref) {
    return '';
  }
  return `background-image : url(${cdnImage(background.value.asset._ref).bg}); min-height: 150px; background-size: cover; background-repeat: no-repeat;`;
});
const lightTextClass = computed(() => {
  return lightText.value ? 'text-www-color-white' : 'text-www-color-neutral-medium-dark';
});
</script>

<style scoped></style>
